<div class="flex flex-column" style="height: 100%;">
  <h2 class="flex items-center mb0 px2 pt2">
    @switch (sfNodeType()) {
      @case ('part') {
        Chapter Settings
      }
      @default {
        Edit
      }
    }

    <div class="flex-auto"></div>

    @if (commands().length) {
      @for (command of commands(); track command.id) {
        <button
          mat-icon-button
          (click)="executeCommand(command)"
          [matTooltip]="command.tooltip"
          class="ml2"
          tabindex="-1"
        >
          <mat-icon [class.negative]="command.id === 'delete'">
            {{command.materialIconName}}
          </mat-icon>
        </button>
      }
    }

    @if (actions().length) {
      @for (action of actions(); track action) {
        @if (action.type === 'button') {
          <button
            mat-icon-button
            [matTooltip]="action.tooltip || ''"
            (click)="executeAction(action)"
            tabindex="-1"
          >
            @if (action.icon) {
              <mat-icon>{{action.icon}}</mat-icon>
            }
            @if (action.label) {
              <span>{{action.label}}</span>
            }
          </button>
        }

        @if (action.type === 'link') {
          <a
            [href]="action.href"
            [target]="action.target || '_blank'"
            mat-icon-button
            [matTooltip]="action.tooltip || ''"
            tabindex="-1"
          >
            @if (action.icon) {
              <mat-icon>{{action.icon}}</mat-icon>
            }
            @if (action.label) {
              <span>{{action.label}}</span>
            }
          </a>
        }
      }
    }
  </h2>

  <mat-dialog-content class="col-12">
    @if (hasNodeMetaDataSchema()) {
      <sfo-dynamic-form
        [jsonSchema]="nodeMetaDataSchema()"
        [renderMode]="renderMode"
        [patchForm]="nodeMetaData()"
        [activeTab]="activeTab()"
        (formValue)="updateForm($event)"
      ></sfo-dynamic-form>
    } @else {
      <div class="px2 py3 text-center">No configurable metadata is available for this element.</div>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" (click)="onSave()">Save</button>
  </mat-dialog-actions>
</div>
